import React from 'react';
import ReactTooltip from 'react-tooltip';
import { QuestionMarkCircleIcon } from '@heroicons/react/outline';
import { useEffect } from 'react';
interface TitleProps {
  title: string;
  tooltip?: string;
}

const Title: React.FC<TitleProps> = ({ title, tooltip }) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  return (
    <div className="font-family-bold text-xl pb-24px flex flex-row items-center">
      <span>{title}</span>
      {tooltip && (
        <>
          <QuestionMarkCircleIcon
            className="ml-1 h-4 w-4"
            data-tip={`<div class="text-left">${tooltip}</div>`}
            data-html={true}
            data-place="right"
            data-for={`sessionGrid-${tooltip}`}
            data-class="text-left !important"
            style={{ textAlign: 'left' }}
          />
          <ReactTooltip id={`sessionGrid-${tooltip}`} />
        </>
      )}
    </div>
  );
};

export default Title;
